/**
 * The title bar's slot for the shell's instance chips.
 *
 * The title bar is a sibling of the shell (`main.tsx`), so the shell cannot
 * render into it by composition — and the chips need the shell's own state: the
 * selections, the busy lock, the pick handlers. Mirroring all of that into a
 * store would be a second copy to keep in step. Instead the title bar offers an
 * empty element here and the shell portals the real controls into it.
 *
 * A store rather than `getElementById` because the element appears *after* the
 * shell mounts (the title bar only draws it once the shell says it is there),
 * and the shell has to be told when it does.
 */

let element: HTMLElement | null = null;
const listeners = new Set<() => void>();

export const titlebarSlot = {
  /** The title bar's ref callback: the slot element, or null when it goes. */
  set(next: HTMLElement | null): void {
    if (next === element) return;
    element = next;
    for (const listener of listeners) listener();
  },
  get(): HTMLElement | null {
    return element;
  },
  subscribe(listener: () => void): () => void {
    listeners.add(listener);
    return () => listeners.delete(listener);
  },
};
